import { Painting } from 'models/painting'
import { getPaintings } from './getPaintings'

export const deletePainting = async (painting, setPaintings) => {
  const formData = new FormData()
  formData.append('data', JSON.stringify(painting))
  await fetch('api/delete', {
    method: 'POST',
    body: formData,
  }).then(async response => {
    const paintings: Painting[] = await getPaintings()
    setPaintings(paintings)
  })
}
